import { Badge } from '@/components/ui'
import { cn } from '@/lib/utils'
import type { WorkflowScheduleOccurrenceReason, WorkflowScheduleOccurrenceStatus } from '@/types'
import { AlertCircle, AlertTriangle, CheckCircle2, Clock, Loader2, SkipForward } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

const STATUS_CONFIG: Record<WorkflowScheduleOccurrenceStatus, { label: string; className: string; Icon: LucideIcon }> = {
  Due: { label: 'Due', className: 'bg-neutral text-neutral-foreground border-neutral-foreground', Icon: Clock },
  Missed: { label: 'Missed', className: 'bg-warning text-warning-foreground border-warning-foreground', Icon: AlertTriangle },
  Triggered: { label: 'Triggered', className: 'bg-info text-info-foreground border-info-foreground', Icon: Loader2 },
  Started: { label: 'Started', className: 'bg-success text-success-foreground border-success-foreground', Icon: CheckCircle2 },
  Skipped: { label: 'Skipped', className: 'bg-neutral text-neutral-foreground border-neutral-foreground', Icon: SkipForward },
  Failed: { label: 'Failed', className: 'bg-danger text-danger-foreground border-danger-foreground', Icon: AlertCircle },
}

interface OccurrenceStatusBadgeProps {
  status: WorkflowScheduleOccurrenceStatus
  reason?: WorkflowScheduleOccurrenceReason
  className?: string
}

export function OccurrenceStatusBadge({ status, reason, className }: OccurrenceStatusBadgeProps) {
  const config = STATUS_CONFIG[status] ?? STATUS_CONFIG.Due
  const Icon = config.Icon
  return (
    <Badge variant="outline" className={cn(config.className, 'gap-1', className)} data-testid="occurrence-status-badge">
      <Icon className={cn('h-3.5 w-3.5 shrink-0', status === 'Triggered' && 'animate-spin')} aria-hidden="true" />
      {reason === 'CaughtUp' ? `${config.label} · caught up` : config.label}
    </Badge>
  )
}
